import React, {useEffect, useMemo} from 'react'
import CardWithTitle from 'components/atoms/CardWithTitle'
import PageTable from 'pages/Analysis/HRVSummary/PageTable'
import useProductManagement from 'features/productManagement/useProductManagement'
import {HRV_SUMMARY_ADVANCED_ID} from 'pages/ProductsPages/constant'

function HRVSummary() {
  const {getAvailableLicenses, listAvailableLicenses} = useProductManagement()

  const isShowSummaryButton = useMemo(() => {
    return Array.from(
      new Set(listAvailableLicenses.map((license) => license.packageItemId)),
    ).some((packageId) => packageId === HRV_SUMMARY_ADVANCED_ID)
  }, [listAvailableLicenses])

  useEffect(() => {
    getAvailableLicenses()
  }, [])

  return (
    <CardWithTitle>
      <PageTable isShowSummaryButton={isShowSummaryButton} />
    </CardWithTitle>
  )
}

export default HRVSummary
